var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "rewards", attrs: { id: "rewards" } },
    [
      _c("div", { staticClass: "l-center" }, [
        _c("h2", { staticClass: "title" }),
        _c("div", { staticClass: "participation-award" }, [
          _c("h3", { staticClass: "ff--trajanpro-bold" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.locale.participationReward) + "\n      "
            ),
          ]),
          _c("p", [_vm._v(_vm._s(_vm.locale.enterCode))]),
          _c("div", { staticClass: "cdk" }, [
            _c("div", { staticClass: "cdk__content text-ellipsis" }, [
              _vm._v("\n          " + _vm._s(_vm.code) + "\n        "),
            ]),
            _c("div", {
              directives: [
                { name: "gtag", rawName: "v-gtag:copyCode", arg: "copyCode" },
              ],
              staticClass: "copy",
              attrs: { id: "copy", "data-type": "button" },
            }),
          ]),
        ]),
        _c("div", { staticClass: "lucky-game" }, [
          _c("h3", { staticClass: "lucky-game__title ff--trajanpro-bold" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.locale.questScratchcards) + "\n      "
            ),
          ]),
          _c("p", { staticClass: "lucky-game__descr" }, [
            _c("span", [_vm._v(_vm._s(_vm.locale.winAmazonCards))]),
            _c("br"),
            _c("span", [_vm._v(_vm._s(_vm.locale.scratch5cards))]),
          ]),
          _c("div", { staticClass: "lucky-game-content" }, [
            _c(
              "div",
              {
                staticClass: "lucky-game-content__inner",
                class: {
                  "lucky-game-content--disabled":
                    _vm.isDisabled && !_vm.isDrawing,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "award", class: { sorry: !_vm.round } },
                  [
                    _vm.round
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("images/kv/award_4.png"),
                              alt: "award",
                            },
                          }),
                          _c("span", [
                            _vm._v("amazon card $" + _vm._s(_vm.round)),
                          ]),
                        ]
                      : _c("span", { staticClass: "ff--trajanpro-bold" }, [
                          _vm._v(_vm._s(_vm.$locale.dialog.award.sorry)),
                        ]),
                  ],
                  2
                ),
                _c("img", {
                  staticClass: "mask",
                  attrs: {
                    src: require("images/rewards/game_mask.png"),
                    id: "redux",
                  },
                }),
              ]
            ),
            _vm.isDrawing
              ? _c(
                  "span",
                  {
                    staticClass: "skip ff--trajanpro-bold",
                    attrs: { "data-type": "button" },
                    on: { click: _vm.skip },
                  },
                  [_vm._v("SKIP")]
                )
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "draw-start",
                style: _vm.isDrawing ? "pointer-events: none" : "",
                attrs: {
                  "element-loading-text": "loading...",
                  "element-loading-background": "rgba(0,0,0,.4)",
                },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "gtag",
                        rawName: "v-gtag:scratch",
                        arg: "scratch",
                      },
                    ],
                    class: ["dialog-btn", _vm.isDisabled && "is-disabled"],
                    attrs: { "data-type": "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.draw.apply(null, arguments)
                      },
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.locale.draw.scratch))])]
                ),
                _c("span", { staticClass: "text ff--trajanpro-bold" }, [
                  _vm._v(
                    _vm._s(_vm.locale.draw.chancesRemaining) +
                      ": " +
                      _vm._s(_vm.times)
                  ),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "table complete-list ff--trajanpro-bold" }, [
            _c("div", { staticClass: "thead" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(_vm.locale.task.method)),
                ]),
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(_vm.locale.task.chancesEarned)),
                ]),
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(_vm.locale.task.progress)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "tbody" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(_vm.locale.task.loginGame)),
                ]),
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(Number(_vm.taskStatus.isLogin)) + "/1"),
                ]),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _vm.taskStatus.isLogin
                      ? [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.locale.task.completed) +
                              "\n              "
                          ),
                        ]
                      : [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.locale.task.notCompleted) +
                              "\n              "
                          ),
                        ],
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(_vm.locale.task.sharePage)),
                ]),
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(Number(_vm.taskStatus.isShare)) + "/1"),
                ]),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _vm.taskStatus.isShare
                      ? [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.locale.task.completed) +
                              "\n              "
                          ),
                        ]
                      : [
                          _c(
                            "span",
                            {
                              staticClass: "progress highlight",
                              attrs: { "data-type": "link" },
                              on: {
                                click: function ($event) {
                                  return _vm.doTask("share", "open")
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.locale.task.toShare))]
                          ),
                        ],
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(_vm.locale.task.chooseCivi)),
                ]),
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(Number(_vm.taskStatus.isJoined)) + "/1"),
                ]),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _vm.taskStatus.isJoined
                      ? [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.locale.task.completed) +
                              "\n              "
                          ),
                        ]
                      : [
                          _c(
                            "span",
                            {
                              staticClass: "progress highlight",
                              attrs: { "data-type": "link" },
                              on: {
                                click: function ($event) {
                                  return _vm.doTask("join")
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.locale.task.toJoin))]
                          ),
                        ],
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(_vm.locale.task.reachLv8)),
                ]),
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(Number(_vm.taskStatus.isReachlv8)) + "/1"),
                ]),
                _c("div", { staticClass: "col" }, [
                  _vm._v(
                    "\n              level\n              " +
                      _vm._s(
                        (_vm.userInfo &&
                          _vm.userInfo.user_info &&
                          _vm.userInfo.user_info.town_center_level) ||
                          0
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(_vm.locale.task.researchPathfinding)),
                ]),
                _c("div", { staticClass: "col" }, [
                  _vm._v(
                    _vm._s(Number(_vm.taskStatus.isResearchPathfinding)) + "/1"
                  ),
                ]),
                _c("div", { staticClass: "col" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.taskStatus.isResearchPathfinding
                          ? _vm.locale.task.completed
                          : _vm.locale.task.notCompleted
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(_vm.locale.task.reach10000)),
                ]),
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(Number(_vm.taskStatus.isReach10k)) + "/1"),
                ]),
                _c("div", { staticClass: "col" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        (_vm.userInfo &&
                          _vm.userInfo.user_info &&
                          _vm.userInfo.mission_combat_power) ||
                          0
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                { name: "gtag", rawName: "v-gtag:refresh", arg: "refresh" },
              ],
              staticClass: "refresh ff--trajanpro-bold",
              class: { "is-refresh": _vm.isRefresh },
              attrs: { "data-type": "link" },
              on: { click: _vm.refresh },
            },
            [_vm._v("\n        Refresh\n      ")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "gtag",
                  rawName: "v-gtag:prizeHistory",
                  arg: "prizeHistory",
                },
              ],
              staticClass: "winning-record ff--trajanpro-bold",
              attrs: { "data-type": "link" },
              on: {
                click: function ($event) {
                  return _vm.record("open")
                },
              },
            },
            [_c("span", [_vm._v(_vm._s(_vm.locale.draw.prizeHistory))])]
          ),
        ]),
      ]),
      _c("DlgShare", {
        attrs: { visible: _vm.shareVisible },
        on: {
          close: function ($event) {
            return _vm.doTask("share", "close")
          },
        },
      }),
      _c("DlgAward", {
        attrs: { round: _vm.round, visible: _vm.visible },
        on: {
          close: function ($event) {
            return _vm.award("close")
          },
        },
      }),
      _c("DlgRecords", {
        attrs: { uid: _vm.uid, visible: _vm.recordVisible },
        on: {
          close: function ($event) {
            return _vm.record("close")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }